import React from "react";

const Dashboard = () => {
  return <div>Customer Dashboard</div>;
};

export default Dashboard;
